import {ActivityIndicator, View} from "react-native";
import {basicStyles} from "../../../../../styles/basic";
import AppText from "../../../../../components/AppText";
import {textStyles} from "../../../../../styles/text";
import AppButton from "../../../../../components/AppButton";
import {generateUuid} from "../../../../../utilities/methods";
import React, {useState, useEffect, useCallback} from "react";
import {bindActionCreators} from "redux";
import {setWarning} from "../../../../../store/warning/warningActions";
import {connect} from "react-redux";
import EStyleSheet from "react-native-extended-stylesheet";
import ContentSection from "../../../../../components/ContentSection";
import MessagesService from "../../../../../services/MessagesService";
import AutomationModal from "./components/AutomationModal";
import ToggleField from "../../../../../components/ToggleField";
import {useDimensions} from "../../../../../hooks/useDimensions";

function Automations({organizationId, setScrollEnabled}) {
    const {isMobile} = useDimensions();

    const [automations, setAutomations] = useState([]);
    const [automationDefs, setAutomationDefs] = useState({
        types: [],
        actions: [],
        conditionTypes: [],
        conditionOperators: [],
        logicalOperators: [],
    });
    const [automationsFetched, setAutomationsFetched] = useState(false);
    const [modalState, setModalState] = useState({
        active: false,
        automationId: null
    });

    const updateAutomationActive = async (automationId, value) => {
        // find the automation in automations with the matching message_automation_id and toggle the value
        let updatedId = null;
        let updatedAutomations = automations.map(automation => {
            console.log('automation', automation);
            if (automation.message_automation_id == automationId) {
                automation.message_automation_active = value;
                updatedId = automationId;
            }
            return automation;
        });

        try {
            if (updatedId) {
                await MessagesService.updateAutomationActiveStatus(organizationId, updatedId, value);

                setAutomations(updatedAutomations);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const deleteAutomation = useCallback(async (automationId) => {
        try {
            await MessagesService.deleteAutomation(organizationId, automationId);

            setAutomations(() => automations.filter(automation => automation.message_automation_id !== automationId))
        } catch (e) {
            console.log(e);
        }
    });

    useEffect(() => {
        (async () => {
            try {
                const data = await MessagesService.getAutomationConfig(organizationId);
                console.log('defs');
                setAutomationDefs(data);
            } catch (e) {
                console.log(e);
            }
        })();

        (async () => {
            try {
                const data = await MessagesService.getAutomations(organizationId);
                console.log('automations', data.automations);

                if (data.automations) {
                    setAutomations(data.automations);
                }
            } catch (err) {
                console.log(err);
            } finally {
                setAutomationsFetched(true);
            }
        })();
    }, [organizationId]);


    return (
        <View style={{marginBottom: 50}}>
            <View
                style={[basicStyles.flexRow, basicStyles.justifyContentSpaceBetween, basicStyles.alignContentCenter, {marginBottom: 25}]}>
                <AppText style={[textStyles.pageSubTitle, textStyles.semiBold, {marginBottom: 0}]}>
                    Automations
                </AppText>
                <AppButton
                    label="Add Automation"
                    action={() => {
                        setModalState({
                            active: true,
                            automationId: null
                        });
                        setScrollEnabled(false)
                    }}
                />
            </View>

            {
                !automationsFetched ?
                    <ActivityIndicator size="large" color="#467AFF"/>
                    : null
            }

            {automationsFetched && automations.length > 0 && (
                <View>
                    {automations.map((automation, index) => (
                        <ContentSection key={automation.message_automation_id} style={[
                            basicStyles.inputContainerPaddingVertical,
                            basicStyles.inputContainerPaddingHorizontal,
                            {marginBottom: 15}
                        ]}>
                            <View style={[
                                isMobile ? null : basicStyles.flexRow,
                                basicStyles.justifyContentSpaceBetween,
                                basicStyles.alignContentCenter
                            ]}>
                                <View style={styles.automationInfo}>
                                    <AppText style={[textStyles.semiBold, {fontSize: 16, marginBottom: 5}]}>
                                        {automation.message_automation_title || `${automation.message_automation_type_title} → ${automation.message_automation_action_title}`}
                                    </AppText>

                                    <AppText style={{fontSize: 12, color: '#999'}}>
                                        Status: {parseInt(automation.message_automation_active) === 1 ? 'Active' : 'Inactive'}
                                    </AppText>
                                </View>

                                <View style={[
                                    basicStyles.flexRow,
                                    basicStyles.alignContentCenter,
                                    isMobile && {
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 1fr',
                                    }
                                ]}>
                                    <ToggleField
                                        label="Enabled"
                                        value={parseInt(automation.message_automation_active) === 1}
                                        onChange={value => {
                                            updateAutomationActive(automation.message_automation_id, value ? 1 : 0);
                                        }}
                                        wrapperStyle={[styles.inputWrapper, {border: 'none'}]}
                                    />

                                    <AppButton
                                        label="Edit"
                                        action={() => {
                                            setModalState({
                                                active: true,
                                                automationId: automation.message_automation_id
                                            });
                                            setScrollEnabled(false);
                                        }}
                                        style={{marginRight: 10}}
                                        theme="transBlue"
                                    />
                                    <AppButton
                                        label="Delete"
                                        action={() => {
                                            // TODO: Add delete functionality
                                            console.log('Delete automation:', automation.message_automation_id);
                                            const confirmDelete = window.confirm('Are you sure you want to delete this automation?');
                                            if (confirmDelete) {
                                                deleteAutomation(automation.message_automation_id);
                                            }
                                        }}
                                        theme="transRed"
                                    />
                                </View>
                            </View>
                        </ContentSection>
                    ))}
                </View>
            )}

            {automationsFetched && automations.length === 0 && (
                <ContentSection style={[
                    basicStyles.inputContainerPaddingVertical,
                    basicStyles.inputContainerPaddingHorizontal,
                    basicStyles.alignContentCenter,
                    basicStyles.justifyContentCenter
                ]}>
                    <AppText>
                        No Automations Currently Configured
                    </AppText>
                </ContentSection>
            )}

            <AutomationModal
                active={modalState.active}
                organizationId={organizationId}
                automationId={modalState.automationId}
                automationDefs={automationDefs}
                onClose={() => {
                    setModalState({
                        active: false,
                        automationId: null
                    });
                    setScrollEnabled(true);
                }}
                onSubmit={(automation) => {
                    // Refresh automations list
                    MessagesService.getAutomations(organizationId)
                        .then((data) => {
                            if (data.automations) {
                                setAutomations(data.automations);
                            }
                        });
                    setModalState({
                        active: false,
                        automationId: null
                    });
                    setScrollEnabled(true);
                }}
            />
        </View>
    )
}


export default Automations;

const styles = EStyleSheet.create({
    heading: {
        fontFamily: 'SourceSansPro-Bold',
        paddingLeft: 22,
        fontSize: 16,
        marginBottom: 10
    },
    subHeading: {
        fontFamily: 'SourceSansPro-Bold',
        paddingLeft: 22
    },
    toggleWrapper: {
        minWidth: 130
    },
    inputWrapper: {
        minWidth: 170,
        flex: 1
    },
    deleteIcon: {
        position: 'absolute',
        top: 15,
        right: 15
    },
    automationInfo: {
        flex: 1,
        marginRight: 15
    }
});
